import { useRequestModalStore } from "./request-modal.store";

export function useRequestModal() {
  const isOpen = useRequestModalStore((s) => s.isOpen);
  const open = useRequestModalStore((s) => s.open);
  const close = useRequestModalStore((s) => s.close);

  return {
    open,
    close,
    isOpen,
  };
}
